module.exports = __webpack_public_path__ + "img/email.90dde670.svg";